module.exports = __webpack_public_path__ + "img/teacher_6.5b94fa46.png";